import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import ApplyBidDetailsPage from "../components/applyBidDetailsPage";
import { useLocation } from "react-router-dom";

const ApplyForBids = () => {
    const location = useLocation();
    const from = location.state?.from;
    return (
        <Box>
            <CustomAppBar active="bids" />
            <ApplyBidDetailsPage/>
        </Box>
    );
}

export default ApplyForBids;